/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function collapseTextSections() {
    const lineClamp = 2;                // lines to keep
    const mobileMax = 767;              // px breakpoint

    if (window.innerWidth > mobileMax) return;

    document.querySelectorAll('.text-section .text__content').forEach((el) => {
      if (el.dataset.collapsible === 'true') return;          // already done

      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      if (!lineHeight) return;

      const maxHeight = lineHeight * lineClamp;
      if (el.scrollHeight <= maxHeight + 1) return;           // short text

      el.classList.add('collapsed');
      el.dataset.collapsible = 'true';

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'text-read-more';
      btn.textContent = 'Read More';

      btn.addEventListener('click', () => {
        const isCollapsed = el.classList.toggle('collapsed');
        btn.textContent = isCollapsed ? 'Read More' : 'Read Less';
      });

      el.after(btn);
    });
  }

  document.addEventListener('DOMContentLoaded', collapseTextSections);


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
